import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeFields", "closedCheckbox"]

  closedChanged() {
    const closed = this.closedCheckboxTarget.checked
    this.timeFieldsTarget.style.display =
      closed ? "none" : ""
  }
}
